const HttpService = require('./http.service');
const resource = '/tasks';


/**
 * Create task.
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
const create = async (payload) => {
    return await HttpService.post(resource, payload);
};

/**
 * Get task.
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
const get = async (params) => {
    return await HttpService.get(resource, params);
};

/**
 * Get task by id.
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
const getById = async (id) => {
    return await HttpService.get(`${resource}/${id}`);
};

/**
 * Update task.
 * @param id
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
const update = async (id, payload) => {
    return await HttpService.put(`${resource}/${id}`, payload);
};

/**
 * Delete task by id.
 * @param id
 * @returns {Promise<AxiosResponse<any>>}
 */
const deleteById = async (id) => {
    return await HttpService.delete(`${resource}/${id}`);
};

module.exports = {
    create,
    get,
    getById,
    update,
    deleteById
};
